module.exports = __webpack_public_path__ + "img/A58A0536.7d428d01.jpg";